<div #loaderContainer class="loader-container hide">
  <app-pre-loader class="pre-loader"></app-pre-loader>
</div>
<div #contentContainer class="content hide">
  <ng-content *ngIf="!loaderState?.error; else error" select="[loader-content]"></ng-content>
  <ng-template #error>
    <ng-content select="[loader-error]"> </ng-content>
  </ng-template>
</div>
